import React from 'react';
import { Accordion, Panel } from 'baseui/accordion';
import './ExperienceAccordion.css';
import { experience } from '../experience';
import ExperienceCard from '../experienceCard/ExperienceCard';

const ExperienceAccordion = () => {
  return (
    <div className='experience-accord'>
      <Accordion onChange={({ expanded }) => console.log(expanded)}>
        {experience.sections.map((section) => {
          return (
            <Panel
              className='accord-panel'
              title={section['title']}
              key={section['title']}
            >
              {section['experiences'].map((experience) => {
                return <ExperienceCard experience={experience} />;
              })}
            </Panel>
          );
        })}
      </Accordion>
    </div>
  );
};

export default ExperienceAccordion;
